import NewBillingItemPage from "@/components/screens/billing_item/new";

export default function NewBillingItem() {
  return <NewBillingItemPage />;
}
